import { createErrorObj } from "@phosphor/utils";
import type { DisposePool } from "@phosphor/utils";
import { type Atom, type PrimitiveAtom, atom } from "jotai";
import { MapOrSetDefault } from "../js/MapOrSetDefault.ts";
import type { JotaiStore } from "./jotai-types.ts";

/**
 * Easy data structure to create a quick map from a key to some replayed last event.
 */
export class JotaiPubSub<K extends string | symbol | Atom<any>, T extends object | number> {
  #store: JotaiStore;
  private map = new MapOrSetDefault<PrimitiveAtom<T | undefined>, K>(() => atom<T | undefined>(undefined));

  constructor(
    store: JotaiStore,
    public readonly name: string,
    pool: DisposePool,
  ) {
    this.#store = store;
    pool.add(() => {
      this.map.clear();
      this.map = createErrorObj("PubSub disposed");
    });
  }

  emit(key: K, value: T) {
    this.#store.set(this.map.getOrSetDefault(key), value);
  }

  delete(key: K): boolean {
    return this.map.delete(key);
  }

  getAtom(key: K): Atom<T | undefined> {
    return this.map.getOrSetDefault(key);
  }
}
